import { createSelector } from '@ngrx/store';
import { getJobsiteState, getSelectedBusinessLine } from '../../../reducers';
import { getLegalEntity } from '@cemex/cmx-client-layout';

export const getPaymentTermsRequestData = createSelector(
  getLegalEntity,
  getSelectedBusinessLine,
  getJobsiteState,
  (customer, businessLine, jobsite) => {
    return {
      countryCode: customer.countryCode,
      productLineId: businessLine.productTypeId,
      jobsiteId: jobsite.selected.shipmentLocationId,
      customerId: customer.legalEntityId,
    };
  },
);
